import React, { useState, useEffect } from 'react'
import api from '../../services/api'
import Icon from '../../components/Icon'
import { Button } from '../../components/ui'
import { translateApiError } from '../../utils/errorMessages'
import './Admin.css'
import './Roles.css'

// Определение всех возможных прав в системе
export const ALL_PERMISSIONS = [
  {
    category: 'Пользователи',
    permissions: [
      { code: 'users.view', name: 'Просмотр пользователей' },
      { code: 'users.create', name: 'Создание пользователей' },
      { code: 'users.update', name: 'Редактирование пользователей' },
      { code: 'users.delete', name: 'Удаление пользователей' }
    ]
  },
  {
    category: 'Роли',
    permissions: [
      { code: 'roles.view', name: 'Просмотр ролей' },
      { code: 'roles.update', name: 'Редактирование прав ролей' }
    ]
  },
  {
    category: 'Комментарии',
    permissions: [
      { code: 'comments.view', name: 'Просмотр комментариев' },
      { code: 'comments.create', name: 'Создание комментариев' },
      { code: 'comments.update', name: 'Редактирование комментариев' },
      { code: 'comments.delete', name: 'Удаление комментариев' }
    ]
  },
  {
    category: 'Сотрудники',
    permissions: [
      { code: 'employees.view', name: 'Просмотр сотрудников' },
      { code: 'employees.create', name: 'Создание сотрудников' },
      { code: 'employees.update', name: 'Редактирование сотрудников' },
      { code: 'employees.delete', name: 'Удаление сотрудников' }
    ]
  },
  {
    category: 'Подразделения',
    permissions: [
      { code: 'departments.view', name: 'Просмотр подразделений' },
      { code: 'departments.create', name: 'Создание подразделений' },
      { code: 'departments.update', name: 'Редактирование подразделений' },
      { code: 'departments.delete', name: 'Удаление подразделений' }
    ]
  },
  {
    category: 'Команды',
    permissions: [
      { code: 'teams.view', name: 'Просмотр команд' },
      { code: 'teams.create', name: 'Создание команд' },
      { code: 'teams.update', name: 'Редактирование команд' },
      { code: 'teams.delete', name: 'Удаление команд' }
    ]
  },
  {
    category: 'Пользовательские поля',
    permissions: [
      { code: 'custom_fields.view', name: 'Просмотр пользовательских полей' },
      { code: 'custom_fields.manage', name: 'Управление пользовательскими полями' }
    ]
  },
  {
    category: 'Настройки',
    permissions: [
      { code: 'settings.system_params', name: 'Параметры системы (НДС, цены)' }
    ]
  },
  {
    category: 'Синхронизация',
    permissions: [
      { code: 'sync.view', name: 'Просмотр синхронизации' },
      { code: 'sync.manage', name: 'Управление синхронизацией' }
    ]
  },
  {
    category: 'Справочники',
    permissions: [
      { code: 'reference.view', name: 'Просмотр справочников' },
      { code: 'reference.manage', name: 'Управление справочниками' }
    ]
  },
  {
    category: 'Удаленные записи',
    permissions: [
      { code: 'deleted_records.view', name: 'Просмотр удаленных записей' },
      { code: 'deleted_records.restore', name: 'Восстановление записей' },
      { code: 'deleted_records.delete', name: 'Окончательное удаление' }
    ]
  },
  {
    category: 'Финансы',
    permissions: [
      { code: 'financial.view', name: 'Просмотр финансовых данных' }
    ]
  },
  {
    category: 'Отчетность',
    permissions: [
      { code: 'reports.view', name: 'Просмотр отчетов' },
      { code: 'reports.create', name: 'Создание отчетов' },
      { code: 'reports.update', name: 'Редактирование отчетов' },
      { code: 'reports.archive', name: 'Архивация отчетов' }
    ]
  },
  {
    category: 'Клиенты',
    permissions: [
      { code: 'clients.view', name: 'Просмотр клиентов' },
      { code: 'clients.create', name: 'Создание клиентов' },
      { code: 'clients.update', name: 'Редактирование клиентов' },
      { code: 'clients.delete', name: 'Удаление клиентов' }
    ]
  },
  {
    category: 'Контакты',
    permissions: [
      { code: 'contacts.view', name: 'Просмотр контактов' },
      { code: 'contacts.create', name: 'Создание контактов' },
      { code: 'contacts.update', name: 'Редактирование контактов' },
      { code: 'contacts.delete', name: 'Удаление контактов' }
    ]
  },
  {
    category: 'Объекты',
    permissions: [
      { code: 'objects.view', name: 'Просмотр объектов' },
      { code: 'objects.create', name: 'Создание объектов' },
      { code: 'objects.update', name: 'Редактирование объектов' },
      { code: 'objects.delete', name: 'Удаление объектов' }
    ]
  },
  {
    category: 'Договоры',
    permissions: [
      { code: 'contracts.view', name: 'Просмотр договоров' },
      { code: 'contracts.create', name: 'Создание договоров' },
      { code: 'contracts.update', name: 'Редактирование договоров' },
      { code: 'contracts.delete', name: 'Удаление договоров' }
    ]
  },
  {
    category: 'Бюджеты стадий',
    permissions: [
      { code: 'stages.view', name: 'Просмотр бюджетов стадий' },
      { code: 'stages.create', name: 'Создание бюджетов стадий' },
      { code: 'stages.update', name: 'Редактирование бюджетов стадий' },
      { code: 'stages.delete', name: 'Удаление бюджетов стадий' }
    ]
  },
  {
    category: 'Этапы объекта',
    permissions: [
      { code: 'object_stages.view', name: 'Просмотр этапов объекта', aliasOf: 'stages.view' },
      { code: 'object_stages.create', name: 'Создание этапов объекта', aliasOf: 'stages.create' },
      { code: 'object_stages.update', name: 'Редактирование этапов объекта', aliasOf: 'stages.update' },
      { code: 'object_stages.delete', name: 'Удаление этапов объекта', aliasOf: 'stages.delete' }
    ]
  },
  {
    category: 'Акты',
    permissions: [
      { code: 'acts.view', name: 'Просмотр актов' },
      { code: 'acts.create', name: 'Создание актов' },
      { code: 'acts.update', name: 'Редактирование актов' },
      { code: 'acts.delete', name: 'Удаление актов' }
    ]
  }
]

const EXTRA_PERMISSION_META = {
  'budgets.view': { category: 'Бюджеты', name: 'Просмотр бюджетов' },
  'budgets.create': { category: 'Бюджеты', name: 'Создание бюджетов' },
  'budgets.update': { category: 'Бюджеты', name: 'Редактирование бюджетов' },
  'budgets.delete': { category: 'Бюджеты', name: 'Удаление бюджетов' },
  'team.view': { category: 'Команда', name: 'Просмотр команды' },
}

function findPermissionDefinition (code) {
  for (const category of ALL_PERMISSIONS) {
    const found = category.permissions.find((perm) => perm.code === code)
    if (found) return found
  }
  return null
}

function getLinkedPermissionCodes (permissionCode) {
  const codes = new Set([permissionCode])
  const entry = findPermissionDefinition(permissionCode)
  if (entry?.aliasOf) codes.add(entry.aliasOf)
  ALL_PERMISSIONS.forEach((category) => {
    category.permissions.forEach((perm) => {
      if (perm.aliasOf === permissionCode) codes.add(perm.code)
    })
  })
  return [...codes]
}

function AdminRoles() {
  const [roles, setRoles] = useState([])
  const [loading, setLoading] = useState(true)
  const [rolePermissions, setRolePermissions] = useState({})
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState({ type: '', text: '' })
  const [isEditing, setIsEditing] = useState(false)
  const [originalPermissions, setOriginalPermissions] = useState({})

  useEffect(() => {
    fetchRoles()
  }, [])

  const fetchRoles = async () => {
    try {
      setLoading(true)
      const response = await api.get('/admin/roles')
      const rolesData = response.data.roles || []
      setRoles(rolesData)
      
      // Инициализируем права для каждой роли
      const permissionsMap = {}
      rolesData.forEach(role => {
        permissionsMap[role.code] = role.permissions || {}
      })
      setRolePermissions(permissionsMap)
      setOriginalPermissions(JSON.parse(JSON.stringify(permissionsMap)))
    } catch (error) {
      console.error('Error fetching roles:', error)
      setMessage({ type: 'error', text: 'Ошибка загрузки ролей: ' + translateApiError(error.response?.data?.error || error.message) })
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = () => {
    setIsEditing(true)
    // Сохраняем текущие права как исходные для отмены
    setOriginalPermissions(JSON.parse(JSON.stringify(rolePermissions)))
  }

  const handleCancel = () => {
    // Восстанавливаем исходные права
    setRolePermissions(JSON.parse(JSON.stringify(originalPermissions)))
    setIsEditing(false)
  }

  const handlePermissionChange = (roleCode, permissionCode, value) => {
    if (!isEditing) return

    const codesToUpdate = getLinkedPermissionCodes(permissionCode)

    setRolePermissions(prev => {
      const nextRole = { ...prev[roleCode] }
      codesToUpdate.forEach((code) => {
        nextRole[code] = value
      })
      return {
        ...prev,
        [roleCode]: nextRole,
      }
    })
  }

  const handleSaveAll = async () => {
    try {
      setSaving(true)
      
      // Сохраняем права для каждой роли
      const savePromises = roles.map(role => {
        const permissions = rolePermissions[role.code] || {}
        return api.put(`/admin/roles/${role.code}/permissions`, {
          permissions
        })
      })
      
      await Promise.all(savePromises)
      
      setMessage({ type: 'success', text: 'Все права успешно сохранены' })
      setOriginalPermissions(JSON.parse(JSON.stringify(rolePermissions)))
      setIsEditing(false)
      
      // Очищаем сообщение через 3 секунды
      setTimeout(() => setMessage({ type: '', text: '' }), 3000)
    } catch (error) {
      console.error('Error saving permissions:', error)
      setMessage({ type: 'error', text: 'Ошибка сохранения прав: ' + translateApiError(error.response?.data?.error || error.message) })
    } finally {
      setSaving(false)
    }
  }

  const getPermissionValue = (roleCode, permissionCode) => {
    const direct = rolePermissions[roleCode]?.[permissionCode]
    if (direct != null) return direct
    const aliasEntry = findPermissionDefinition(permissionCode)
    if (aliasEntry?.aliasOf) {
      return rolePermissions[roleCode]?.[aliasEntry.aliasOf] ?? false
    }
    return false
  }

  const getAllPermissionsFlat = () => {
    const flat = []
    const known = new Set()

    ALL_PERMISSIONS.forEach(category => {
      category.permissions.forEach(perm => {
        known.add(perm.code)
        if (perm.aliasOf) known.add(perm.aliasOf)
        flat.push({
          ...perm,
          category: category.category
        })
      })
    })

    const dbPermissionCodes = new Set()
    roles.forEach((role) => {
      const perms = rolePermissions?.[role.code] || {}
      Object.keys(perms).forEach((code) => dbPermissionCodes.add(code))
    })

    const unknown = Array.from(dbPermissionCodes)
      .filter((code) => !known.has(code))
      .sort()

    if (unknown.length > 0) {
      unknown.forEach((code) => {
        const meta = EXTRA_PERMISSION_META[code]
        flat.push({
          code,
          name: meta?.name || code.replaceAll('.', ' · '),
          category: meta?.category || 'Дополнительные права',
        })
      })
    }

    return flat
  }

  if (loading) {
    return (
      <div className="admin-page">
        <div className="loading">Загрузка...</div>
      </div>
    )
  }

  const allPermissions = getAllPermissionsFlat()
  let currentCategory = ''

  return (
    <div className="admin-page">
      <div className="admin-header">
        <p className="admin-subtitle">Настройка прав доступа для каждой роли</p>
      </div>

      {message.text && (
        <div className={`admin-message admin-message-${message.type}`}>
          {message.text}
          <Button
            type="button"
            variant="ghost"
            className="message-close"
            onClick={() => setMessage({ type: '', text: '' })}
            aria-label="Закрыть"
          >
            ×
          </Button>
        </div>
      )}

      <div className="roles-table-container ui-card">
        <div className="roles-table-header">
          <div className="roles-table-actions">
            {!isEditing ? (
              <Button variant="primary" onClick={handleEdit}>
                <Icon name="edit" size={16} />
                Редактировать
              </Button>
            ) : (
              <>
                <Button variant="secondary" onClick={handleCancel} disabled={saving}>
                  Отменить
                </Button>
                <Button variant="primary" onClick={handleSaveAll} disabled={saving}>
                  {saving ? 'Сохранение...' : 'Сохранить'}
                </Button>
              </>
            )}
          </div>
        </div>

        <div className="roles-table-wrapper">
          <table className="roles-table ui-table">
            <thead>
              <tr>
                <th className="roles-table-permission-col">Право</th>
                {roles.map(role => (
                  <th key={role.code} className="roles-table-role-col">
                    <div className="role-header">
                      <div className="role-header-name">{role.name}</div>
                      <div className="role-header-code">{role.code}</div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPermissions.map((perm, index) => {
                const showCategory = currentCategory !== perm.category
                if (showCategory) {
                  currentCategory = perm.category
                }
                
                return (
                  <React.Fragment key={perm.code}>
                    {showCategory && (
                      <tr className="roles-table-category-row">
                        <td colSpan={roles.length + 1} className="roles-table-category">
                          <Icon name="grid" size={16} />
                          {perm.category}
                        </td>
                      </tr>
                    )}
                    <tr className="roles-table-permission-row">
                      <td className="roles-table-permission">
                        <div className="permission-info">
                          <span className="permission-name">{perm.name}</span>
                          <span className="permission-code">{perm.code}</span>
                        </div>
                      </td>
                      {roles.map(role => {
                        const isAllowed = getPermissionValue(role.code, perm.code)
                        return (
                          <td key={role.code} className="roles-table-checkbox">
                            <label className={`permission-checkbox-label ${!isEditing ? 'disabled' : ''}`}>
                              <input
                                type="checkbox"
                                checked={isAllowed}
                                onChange={(e) => handlePermissionChange(role.code, perm.code, e.target.checked)}
                                className="permission-checkbox"
                                disabled={!isEditing}
                              />
                              <span className="permission-checkbox-custom"></span>
                            </label>
                          </td>
                        )
                      })}
                    </tr>
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default AdminRoles
